/*const variable for Restservice calls - key table values */
// key table values for budget source types
export const BUDGET_SOURCE_TYPE_VALUES = 'budgetSourceTypeValue';
// key table values for budget source category
export const BUDGET_SOURCE_CATEGORY_VALUES = 'budgetSourceCategoryValue';
// key table values for languages
export const LANGUAGE_VALUES = 'language';
// key table values for kdsf category
export const KDSF_CATEGORY_VALUES = 'funderCategoryKdsf';
// key table values for gender
export const GENDER_VALUES = 'gender';
// key table values for country values
export const COUNTRY_VALUES = 'country';
// key table values for dynamic approval status values
export const DYNAMIC_APPROVAL_STATUS_VALUES = 'dynamicApprovalStatusValue';
// hiskeyIds for budget source category = basic funds - hiskeyId 15
export const CATEGORY_BASIC_FUNDS_HISKEYIDS: number[] = [10, 24, 25];
// hiskeyIds for budget source category = special funds - hiskeyId 16
export const CATEGORY_SPECIAL_FUNDS_HISKEYIDS: number[] = [10, 25, 26, 24];
// hiskeyIds for budget source category = third party funds - hiskeyId 17
export const CATEGORY_THIRD_PARTY_FUNDS_HISKEYIDS: number[] = [10, 25, 24, 27];
// hiskeyIds for budget source category = right of use - hiskeyId 18
export const CATEGORY_RIGHT_OF_USE_HISKEYIDS: number[] = [21, 22, 23, 24];
// hiskeyId for budget source category = funding program
export const CATEGORY_FUNDINGPROGRAMM_HISKEYID = 10;
// hiskeyId for budget source category = none
export const CATEGORY_NONE_HISKEYID = 24;
// hiskeyId for budget source type = right of use
export const TYPE_RIGHT_OF_USE_HISKEYID = 18;
// hiskeyId for budget source type = mixed financing
export const TYPE_MIXED_FINANCING_HISKEYID = 19;
// the maximum number of elements in listview(collapsed)
export const MAX_LIST_ELEMENTS = 3;
// the maximum length of text in collapsible text view
export const MAX_TEXT_LENGTH = 380;
